<ng-container *ngIf="meal !== undefined">
  <div
    *ngIf="meal.translations.itemCategory && meal.translations.itemCategory.length > 0"
    class="meal-details-categories nordic-blue-900-text font-body-1 pr-medium-y"
  >
    <span *ngFor="let category of meal.translations.itemCategory; let i = index">
      {{ i > 0 ? ', ' : ''
      }}{{ 'ancillaries.meals.categories.' + category + '.full' | finLocalization | finEmpty: category }}
    </span>
  </div>
  <div class="nordic-blue-900-text">
    <div
      class="meal-details-description font-body-1"
      *ngIf="meal.translations.description"
      [class.mr-xsmall-b]="meal.translations.ingredients || meal.translations.nutrition"
      [innerHTML]="meal.translations.description"
    ></div>
    <div class="ingredients" *ngIf="meal.translations.ingredients">
      <h3 class="font-body-1">{{ 'ancillaries.meals.details.ingredients' | finLocalization }}:</h3>
      <div class="font-body-1" [innerHTML]="meal.translations.ingredients"></div>
    </div>
    <div class="nutrition" *ngIf="meal.translations.nutrition">
      <h3 class="font-body-1 mr-xsmall-t">{{ 'ancillaries.meals.details.nutritionFacts' | finLocalization }}:</h3>
      <div class="font-body-1" [innerHTML]="meal.translations.nutrition"></div>
    </div>
  </div>
</ng-container>
